<template>
  <div class="w-full min-h-screen bg-gradient-to-b from-[#fff3f7] to-white flex flex-col items-center">
    <!-- Hero Section -->
    <section class="w-full max-w-6xl px-6 lg:px-10 py-16 flex flex-col lg:flex-row items-center justify-between gap-10">

      <!-- Text Section -->
      <div class="flex-1 text-center lg:text-left space-y-6">
        <h1 class="text-4xl md:text-5xl font-extrabold leading-tight font-arabic">
          {{ $t("register.success.main_title") }}
            <span class="text-[#d40c56]">Gifty </span>
          
        </h1>

        <p class="text-gray-700 text-lg leading-relaxed font-arabic">
         {{ $t("register.success.description") }}
        </p>

        <div class="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
          <a href="https://onelink.to/bj77mv"
            class="px-6 py-3 bg-[#d40c56] text-white rounded-full text-base font-bold shadow hover:bg-[#b63753] transition">
                     {{ $t("register.success.download") }}

          </a>

         
        </div>
      </div>

      <!-- Hero Image -->
      <div class="flex-1 flex justify-center">
        <img
          src="https://gifty.dz/wp-content/uploads/2025/10/hero-image-01.webp"
          alt="Illustration Gifty"
          class="w-full max-w-md md:max-w-lg drop-shadow-lg rounded-3xl"
        />
      </div>
    </section>
  </div>
</template>

<script setup>
// No script logic needed for this static homepage yet
</script>

<style scoped>
/* Optional animations or gradients if you want Elementor-like feel */
</style>